// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1718":"f7f4bdaf","2947":"11b01132","8029":"f7f4bdaf","9900":"cde414a5"}[chunkId] + ".chunk.css";
};